type IdObject = { id: string };

/**
 * Function that receive an entity list and the entity
 * id and return an array filtered by id value.
 * @param list => Entity array
 * @param id => Entity id
 */
export function removeItemInArray(list: (string | IdObject)[], id: string): (string | IdObject)[] {
  if (list.length === 0) return [];

  if (typeof list[0] === 'string') {
    return (list as string[]).filter((value) => value !== id);
  }

  return (list as IdObject[]).filter((item) => item.id !== id);
}

export default removeItemInArray;
